import { $Q } from '../utils/querySelector';
import { RenderElements } from '../utils/renderElement';

class Newsletter {
  constructor() {
    this.redirect();
    this.readNewsletterInput();
  }

  /**
   * Validate with the URL if the newsletter form footer was send
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  redirect() {
    const url = window.location.href;

    if (
      (url.includes('?customer_posted=true') ||
        url.includes('form_type=customer')) &&
      !url.includes('my-newsletter-subscription')
    ) {
      window.location.href = '#footer';
    }
  }

  /**
   * Validate URL with has tags and render message.
   * This validation is for when the submit form newsletter,
   * and the email input has already exist,
   * the form let show a message to user, notifying that is subscribed
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  readNewsletterInput() {
    const contactGet = new URLSearchParams(window.location.search).get(
      'contact[tags]'
    );

    if (contactGet) {
      const notificationNode = `
        <small class="form-message form-message--error">
          ${$Q('.newsletter-form input[type=email]').dataset.errorExist}
        </small>
      `;

      new RenderElements().renderTextNodes(
        $Q('.form-message__container'),
        notificationNode,
        'afterbegin'
      );
    }
  }
}

export { Newsletter };
